import React, { useEffect, useState } from 'react';
import { Bar } from 'react-chartjs-2';
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend
} from 'chart.js';

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend
);

const API = window.location.hostname === 'localhost'
  ? 'http://localhost:5000/api'
  : 'https://myssa1.osc-fr1.scalingo.io/api';

const Graph6 = ({ width = 800, height = 600 }) => {
  const [chartData, setChartData] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await fetch(`${API}/montant_achat`);
        const data = await response.json();

        const labels = data.map(item => item["Mois"]);
        const montantY1 = data.map(item => item["Montant livré Y-1"] || 0);
        const montantLivre = data.map(item => item["Montant livré"] || 0);
        const montantALivrer = data.map(item => item["Montant à livrer"] || 0);

        setChartData({
          labels,
          datasets: [
            {
              label: 'Montant livré Y-1',
              data: montantY1,
              backgroundColor: '#919691',
              borderColor: '#919691',
              borderWidth: 1,
              stack: 'Y1',
            },
            {
              label: 'Montant livré',
              data: montantLivre,
              backgroundColor: '#5cc385',
              borderColor: '#5cc385',
              borderWidth: 1,
              stack: 'current',
            },
            {
              label: 'Montant à livrer',
              data: montantALivrer,
              backgroundColor: '#ffb74d',
              borderColor: '#f57c00',
              borderWidth: 1,
              stack: 'current',
            }
          ],
        });
      } catch (error) {
        console.error('Erreur lors du chargement du fichier JSON :', error);
      }
    };

    fetchData();
  }, []);

  const options = {
    responsive: false,
    maintainAspectRatio: false,
    plugins: {
      title: {
        display: true,
        text: 'FOURNISSEUR : Montants par mois',
        font: { size: 16 }
      },
      tooltip: {
        mode: 'index',
        intersect: false,
      },
      legend: {
        position: 'bottom',
      },
      datalabels: {
        display: false
      }
    },
    scales: {
      x: {
        stacked: true,
      },
      y: {
        stacked: true,
        beginAtZero: true,
      },
    },
  };

  return (
    <div>
      {chartData ? (
        <Bar data={chartData} options={options} width={width} height={height} />
      ) : (
        <p>Chargement du graphique...</p>
      )}
    </div>
  );
};

export default Graph6;